module.exports = __webpack_public_path__ + "assets/img/5a94beccef4d31e1f896bcf754161500.svg";